export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8436.e13bd19a.jpg";